import { __awaiter, __generator } from "tslib";
import { bootstrapFeature, initialize, preloadFeature, } from '@ms/centro-hvc-loader';
import { CentroDataSourcesString, OcvInAppFeedback } from './Constants';
import { getCentroParams, logInAppFeedbackError, logInAppFeedbackInfo, validateInitializationParameters, } from './SupportFunctions';
import * as _ from 'lodash';
var InAppFeedbackInitOptionsListener = (function () {
    var feedbackData = {};
    // register listener to Centro to enable dynamic data passing
    var register = function (listener) {
        if (listener) {
            listeners.push(listener);
        }
        return feedbackData;
    };
    // unregister listener from Centro
    var unregister = function (listener) {
        var index = listeners.indexOf(listener);
        if (index > -1) {
            listeners.splice(index, 1);
        }
    };
    // list of function provided to update Feedback configuration
    var listeners = [];
    /**
     *  Updates exisiting properties of the current instance
     */
    var updateFeedbackObject = function (updatedInAppFeedbackInitOptions) {
        var updatedFeedbackData = _.merge({}, feedbackData, updatedInAppFeedbackInitOptions);
        listeners.forEach(function (listener) { return listener(updatedFeedbackData); });
    };
    /**
     * Opens new feedback discarding old values
     */
    var openFeedbackObject = function (initFeedbackData) {
        initFeedbackData.feedbackConfig.isDisplayed = true;
        listeners.forEach(function (listener) { return listener(initFeedbackData); });
    };
    var configObject = {
        register: register,
        unregister: unregister,
        updateFeedbackObject: updateFeedbackObject,
        openFeedbackObject: openFeedbackObject,
    };
    return configObject;
})();
var unmountFunction = function () { };
/**
 * This is function you call from hostapp, please wrap this in a try catch block
 *
 * Details of the data objects and functions can be found here
 * https://projectcentro.azurewebsites.net/docs/#/consume/adapter
 */
function initializeInAppFeedback(initializationInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var bootstrapper;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, validateInitializationParameters(initializationInfo)
                    // Unmounting and closing any previous instances of feedback
                ];
                case 1:
                    _a.sent();
                    // Unmounting and closing any previous instances of feedback
                    unmountFunction();
                    return [4 /*yield*/, loadInAppFeedbackPackage(initializationInfo)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, bootstrapFeature({
                            featureName: OcvInAppFeedback,
                        })
                        // Mounting the HVC on the provided HTML element
                    ];
                case 3:
                    bootstrapper = _a.sent();
                    return [4 /*yield*/, bootstrapper.main(initializationInfo.inAppFeedbackRef)];
                case 4:
                    // Mounting the HVC on the provided HTML element
                    unmountFunction = _a.sent();
                    logInAppFeedbackInfo('InAppFeedback Initialization Completed.');
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * You can use this function pre download the HVC bundle without attaching to the application life cycle.
 */
function loadInAppFeedbackPackage(initializationInfo) {
    return __awaiter(this, void 0, void 0, function () {
        var dataSources, centroAdapter, preloadParameter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, initialize(getCentroParams(initializationInfo)).catch(function (e) {
                        logInAppFeedbackError("InAppFeedback initilization failed at centro initialize function", e);
                    })];
                case 1:
                    _a.sent();
                    dataSources = function (sd) {
                        sd(CentroDataSourcesString, InAppFeedbackInitOptionsListener);
                    };
                    centroAdapter = {
                        dataSources: dataSources,
                    };
                    preloadParameter = { featureName: OcvInAppFeedback, adapters: centroAdapter };
                    return [4 /*yield*/, preloadFeature(preloadParameter).catch(function (e) {
                            logInAppFeedbackError("InAppFeedback initilization failed at centro initialize preloadFeature", e);
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
var updateFeedbackOptions = InAppFeedbackInitOptionsListener.updateFeedbackObject;
var openFeedback = InAppFeedbackInitOptionsListener.openFeedbackObject;
export { updateFeedbackOptions, openFeedback, initializeInAppFeedback, logInAppFeedbackInfo, logInAppFeedbackError, unmountFunction, loadInAppFeedbackPackage, };
